<template>
  <tr>
    <!-- First cell should always appear with plans or first grouping idx. -->
    <td
      v-if="isPlanBased || idx === 0"
      class="cell-attribute-name"
      :rowspan="rowSpan"
      v-text="attributeName"
    />
    <td
      v-if="!isPlanBased"
      v-text="classLabel.replace(/classes|class/gi, '')"
    />
    <td
      v-for="subtype in subtypes"
      :key="`policy-value-${subtype.name}`"
      :colspan="subtypeColspans[containerId] / subtypes.length"
    >
      <template v-if="isPlanBased">
        {{ subtype.plan_design_value.value || '&mdash;' }}
      </template>
      <template v-else>
        {{ subtype.plan_design_values[0].value || '&mdash;' }}
      </template>
    </td>
  </tr>
</template>

<script>
  // vuex
  import { mapGetters, mapState } from 'vuex';
  /**
   * A table row for each of the Plan Design Attributes and their values based on prop and the planDesign store module information.
   *
   * @vuedoc
   * @exports PlanDesignAttribute
   * @category Components
   */
  export default {
    name: 'PlanDesignAttribute',
    props: {
      attributeName: {
        type: String,
        required: true,
      },
      classLabel: {
        type: String,
        default: null,
      },
      containerId: {
        type: [Number, String],
        required: true,
      },
      idx: {
        type: Number,
        required: true,
      },
      rowSpan: {
        type: Number,
        default: 1,
      },
      subtypes: {
        type: Array,
        required: true,
      },
    },
    computed: {
      ...mapGetters('planDesignAttributes', ['isPlanBased']),
      ...mapState('planDesignAttributes', ['subtypeColspans']),
    },
  };

</script>

<style lang="scss" scoped>
.cell-attribute-name {
  vertical-align: top;
}

td {
  border: 1px solid $tf-light-gray;
  padding: 15px 20px;
}
</style>
